export function deepEqual(a: unknown, b: unknown): boolean {
    // Same primitive values or same reference.
    if (a === b) {
        return true;
    }

    // Non-object values are not equal.
    if (typeof a !== 'object' || typeof b !== 'object') {
        return false;
    }

    // Null typeof is "object" but it can not equal an other object.
    if (a === null || b === null) {
        return false;
    }

    // If one is an array and the other isn't, they're not equal.
    const aIsArray = Array.isArray(a);
    const bIsArray = Array.isArray(b);

    if (aIsArray !== bIsArray) {
        return false;
    }

    if (aIsArray && bIsArray) {
        // Both are arrays - compare length and elements by index
        if (a.length !== b.length) {
            return false;
        }

        for (let i = 0; i < a.length; i++) {
            if (!deepEqual(a[i], b[i])) {
                return false;
            }
        }

        return true;
    }

    // Both are objects (not arrays) - compare keys and values.
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);

    if (keysA.length !== keysB.length) {
        return false;
    }

    for (const key of keysA) {
        if (!keysB.includes(key)) {
            return false;
        }
        if (!deepEqual((a as Record<string, unknown>)[key], (b as Record<string, unknown>)[key])) {
            return false;
        }
    }

    return true;
}
